module.exports = __webpack_public_path__ + "img/etica_wtext_0xpool2.7267ebc8.png";